import { Component } from '@angular/core';

@Component({
  selector: 'componenteFooter',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
})
export class FooterComponent {}
